import * as z from "@-/com.npmjs.zod";

export const graphemeStrokeSliceSchema = z.object({
  index: z.int(),
  median: z.array(z.tuple([z.int(), z.int()])),
  path: z.string(),
});

export type GraphemeStrokeSlice = z.infer<typeof graphemeStrokeSliceSchema>;

/**
 * A glyph's stroke geometry in stroke order, or `null` when there is NO Hanzi Writer stroke data for
 * it (rare graphemes and some components have none). For a multi-glyph front the list is `null` as
 * soon as any glyph lacks data — a partial list would draw a wrong character. Consumers render a
 * deliberate no-strokes state (the font glyph) for `null`; an empty list never stands in for
 * "unknown".
 */
export const graphemeStrokeListSchema = z.array(graphemeStrokeSliceSchema).nullable();

export type GraphemeStrokeList = z.infer<typeof graphemeStrokeListSchema>;
